import React, { useState } from "react";
import { graphql } from "gatsby";
import CircleArrow from "../../images/circle-arrow-black.svg";
import ProjectsGrid from "./projectsGrid/projectsGrid";
import { insertUrlParam, getUrlParams } from "../../utils/utils";

export const fragments = graphql`
  fragment Page_ProjectsManual on PrismicPageDataBodyProjectsManual {
    id
    slice_type
    primary {
      projects_manual_initial_size
      projects_manual_load_size
    }
    items {
      projects_manual_projects {
        document {
          ...OnGridProject
        }
      }
    }
  }

  fragment FocusArea_ProjectsManual on PrismicFocusAreaDataBodyProjectsManual {
    id
    slice_type
    primary {
      projects_manual_initial_size
      projects_manual_load_size
    }
    items {
      projects_manual_projects {
        document {
          ...OnGridProject
        }
      }
    }
  }
`;

function ModusWay({ data }) {
  const initialSize =
    getUrlParams("loadSize") ||
    data?.primary?.projects_manual_initial_size ||
    2;
  const loadSize = data?.primary?.projects_manual_load_size || 2;
  const [sliceSize, setSliceSize] = useState(initialSize);
  const projects = data?.items
    .map((i) => i.projects_manual_projects)
    .slice(0, sliceSize);

  const loadMoreHandler = () => {
    setSliceSize(sliceSize + loadSize);
    insertUrlParam("loadSize", sliceSize + loadSize + "");
  };

  return (
    <div className="projects-grid projects-grid__load manual">
      <ProjectsGrid tiles={projects} />
      {sliceSize < data?.items?.length && (
        <button className="load-more" onClick={loadMoreHandler}>
          load more
          <CircleArrow className="circle-arrow" />
        </button>
      )}
    </div>
  );
}

export default ModusWay;
